export const formatScreensaverData = rawData => {
  if (!rawData || rawData.length === 0) return null;

  return {
    text: rawData[0].Text,
  };
};
